import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { reducer as notifications } from "react-notification-system-redux";

import {
  loginReducer,
  signupReducer,
  resetPasswordReducer,
  invateReducer,
  forgotPasswordReducer,
  queryPageRequest,
  queryPageProgramRequest,
  queryPageByIdRequest,
  getRequest,
  getByIdRequest,
  postRequest,
  postByIdRequest,
  postSetRequest,
  putRequest,
  putByIdRequest,
  deleteRequest,
  setRequest,
  downloadRequest,
  reportActivityList,
  reportActivityProfileImage,
  newCount,
  listType
} from "./redux/reducers/index";


const reducer = combineReducers({

  // Notification
  notifications: notifications,

  // Auth
  login: loginReducer,
  signup: signupReducer,
  resetPassword: resetPasswordReducer,
  forgetPass: forgotPasswordReducer,
  invateUser: invateReducer,

  //Master
  interestList: getRequest('interest/list'),
  interestId: getByIdRequest('interest/id'),
  interestDelete: deleteRequest('interest'),
  interestSave: postRequest('interest/save'),

  skillList: getRequest('skill/list'),
  skillId: getByIdRequest('skill/id'),
  skillDelete: deleteRequest('skill'),
  skillSave: postRequest('skill/save'),

  statusList: getRequest('status/list'),

  countryList: getRequest('country/list'),
  countryId: getByIdRequest('country/id'),
  countryDelete: deleteRequest('country'),
  countrySave: postRequest('country/save'),

  languageList: getRequest('language/list'),
  languageId: getByIdRequest('language/id'),
  languageDelete: deleteRequest('language'),
  languageSave: postRequest('language/save'),

  workingAreaList: getRequest('working/area/list'),
  workingAreaId: getByIdRequest('working/area/id'),
  workingAreaDelete: deleteRequest('working/area'),
  workingAreaSave: postRequest('working/area/save'),

  skillInterestSuggestionQueryPage: queryPageRequest("researcher/suggestion"),
  skillSuggestionDelete: deleteRequest("skill"),
  skillSuggestionSave: postRequest("skill/save"),

  programInfoSaveFocusarea: postRequest('program/info/save/focusarea'),
  programInfoGetFocusarea: getRequest('program/info/get/focusarea'),
  programInfoSaveRules: postRequest('program/info/save/rules'),
  programInfoGetRules: getRequest('program/info/get/rules'),
  programInfoSaveEligibility: postRequest('program/info/save/eligibility'),
  programInfoGetEligibility: getRequest('program/info/get/eligibility'),

  validatorSelectList: getRequest('validator/junior/list'),
  seniorValidatorSelectList: getRequest('validator/senior/list'),


  // Dashboard
  userStatOnlineUser: getRequest('user/stat/online/user'),
  programStatPublishedCount: getRequest('program/stat/published/count'),
  programReportStatSubmitted: getRequest('program/report/stat/submitted/count'),
  programStatTotalReward: getRequest('program/stat/total/reward'),

  programStatBountyCount: getRequest('program/stat/bounty/count'),
  programStatStatusCount: getRequest('program/stat/status/count'),

  programReportStatStatusCount: getRequest('program/report/stat/status/count'),
  programReportStatSeverityCount: getRequest('program/report/stat/severity/count'),

  userStatUserTypeCount: getRequest('user/stat/user/type/count'), 

  //Program
  programListType: listType('program'),
  programAllQueryPage: queryPageProgramRequest('program/all'),
  programStat: getByIdRequest('program/stat'),
  programReportStat: getByIdRequest('program/report/stat'),
  programConfirm: putByIdRequest('program/confirm'),
  programReject: postByIdRequest('program/reject'),
  programRevision: postByIdRequest('program/revision'),
  programSuspend: postByIdRequest('program/suspend'),
  programPublish: putByIdRequest('program/publish'),
  programId: getByIdRequest('program/id'),
  programScope: getByIdRequest('program/scope/byprogram'),
  programReward: getByIdRequest('program/reward/byprogram'),
  programPaymentTransactionList: getByIdRequest('program/payment/transaction/list'),
  programPaymentFile: getByIdRequest('program/download/program/payment/file'),
  programUpdatesQueryPage: queryPageByIdRequest('program/update'),
  programUpdateId: getByIdRequest('program/update/id'),
  programUpdateReject: postByIdRequest('program/update/reject'),
  programUpdateAccept: putByIdRequest('program/update/accept'),
  programScopeBeforeUpdateByprogram: getByIdRequest('program/scope/before/update/byprogram'),
  programScopeUpdateByprogram: getByIdRequest('program/scope/update/byprogram'),
  programScopeUpdateAccept: putByIdRequest('program/scope/update/accept'),
  programScopeUpdateReject: postByIdRequest('program/scope/update/reject'),
  programRewardUpdateAccept: putByIdRequest('program/reward/update/accept'),
  programRewardUpdateReject: postByIdRequest('program/reward/update/reject'),
  programResearcherJoinByProgramQueryPage: queryPageByIdRequest('researcher/program/join/byprogram'),
  programReportByProgramQueryPage: queryPageByIdRequest('program/report/byprogram'),
  researcherProgramJoinRecentlyListByprogram: getByIdRequest('researcher/program/join/recently/list/byprogram'),
  //Researcher
  researcherList: queryPageRequest('researcher'),
  researcherProfileBase: getByIdRequest('researcher/profile/base'),
  researcherProfileSub: getByIdRequest('researcher/profile/sub'),
  researcherProfileBadges: getByIdRequest('researcher/profile/badges'),
  researcherProfileSkill: getByIdRequest('researcher/skill/byresearcher'),
  researcherProfileInterest: getByIdRequest('researcher/interest/byresearcher'),
  researcherPaymentMethod: getByIdRequest('researcher/payment/method/byresearcher'),
  researcherFollowedProgram: queryPageByIdRequest('researcher/program/following'),
  researcherJoinedProgram: queryPageByIdRequest('researcher/program/joined'),
  profileResearcherSecurityInformation: queryPageByIdRequest('logging/login/byresearcher'),
  researcherSubmittedReportQueryPage: queryPageByIdRequest('program/report/researcher/submitted'),
  researcherSubmittedReport: getRequest('researcher/report'),
  researcherSetArchived: setRequest('researcher/set/archive'),
  researcherStatProgramReport: getByIdRequest('researcher/stat/program/report'),
  researcherDownloadVerificationImage: getByIdRequest('researcher/download/verification/image'),
  researcherSetVerification: setRequest('researcher/set/verification'),
  
  //Organizations
  organizationList: queryPageRequest('organization'),
  pendingOrganizationList: queryPageRequest('organization/pending/approval'),
  rejectedOrganizationList: queryPageRequest('organization/rejected'),
  organizationSetArchived: setRequest('organization/set/archived'),
  newOrganizatonSave: postRequest('new/organization'),
  organizationProfileBase: getRequest('organization/profile/base'),
  organizationNew: postRequest('organization/save'),
  organizationProfileSub: getByIdRequest('organization/profile/sub'),
  organizationProfileTeam: queryPageByIdRequest('organization/team/member'),
  profileOrganizationSecurityInformation: queryPageByIdRequest('logging/login/byorganization'),
  organizationJobList: queryPageByIdRequest('program'),
  vulnerabilityCategoryList: getRequest('vulnerability/category/list'),
  organizationConfirm: putByIdRequest('organization/confirm'),
  organizationReject: putByIdRequest('organization/reject'),
  researcherStatProgramReport: getByIdRequest('researcher/stat/program/report'),
  organizationStatProgram: getByIdRequest('organization/stat/program'),
  organizationStatReport: getByIdRequest('organization/stat/program/report'),

  
  //Validators
  validatorList: queryPageRequest('validator'),
  newValidatorSave: postRequest('validator/save'),
  validatorProfileBaseInfo: getByIdRequest('validator/profile/base'),
  validatorProfilrSubInfo: getByIdRequest('validator/profile/sub'),
  validatorReportList: queryPageByIdRequest('program/report/validator/assigned'),
  profileValidatorSecurityInformation: queryPageByIdRequest('logging/login/byvalidator'),
  validatorSpecialitiesList: getByIdRequest('validator/interest/byvalidator'),
  validatorArchive: setRequest('validator/set/archived'),
  typeList: getRequest('type/list'),
  validatorStatProgramReport: getByIdRequest('validator/stat/program/report'),
 

  // Payments
  paymentTransactionQueryPage: queryPageRequest('payment/transaction/all'),

  //Monitoring
  systemInfo: getRequest('system/info'),

  //Admins
  newAdminViewer: postRequest('user/admin/save'),
  adminUserList: queryPageRequest('user/admin'),

  //Reports
  programReportQueryPage: queryPageRequest('program/report/all'),
  programReportId: getByIdRequest('program/report/id'),
  programReportActivityByReport: reportActivityList(),
  reportActivityProfileImage: reportActivityProfileImage(),
  programReportAttachmentFileList: getByIdRequest('program/report/attachment/file/list'),
  programReportAttachmentFileDownload: downloadRequest('program/report/attachment/file/download'),  
  programReportActivityAttachmentFileDownload: downloadRequest('program/report/activity/attachment/file/download'),
  programSetValidator: setRequest('program/report/assign/validator'),

  //Profile
  adminProfileInformation: getRequest('admin/profile/base'),
  adminProfileSub: getRequest('admin/profile/sub'),
  adminProfileSecurityInformation: getRequest('security/list'),
  ImageSave: postRequest('user/save/profile/image'),
  adminProfileUpdate: postRequest('admin/profile/personel/details/update'),
  profileAdminSecurityInformation: queryPageRequest('logging/login'),

  //Support 
  supportQueryPage: queryPageRequest('support'),
  supportResponse: postByIdRequest('support/response'),
  supportInfoById: getByIdRequest('support/id'),

  //Live Support 
  liveSupportQueryPage: queryPageRequest('live/support'),
  liveSupportId: getByIdRequest('live/support/id'),
  liveSupportResponse: postByIdRequest('live/support/response'),


  loggingLoginAll: queryPageRequest('logging/login/all'),
  publicAccessAll: queryPageRequest('public/access/all'),
  loggingLoginId: getByIdRequest('logging/login/id'),
  publicAccessId: getByIdRequest('public/access/id'),

   //Notification
   notificationTaskShort: queryPageRequest('notification/task/short'),
   notificationTask: queryPageRequest('notification/task'),
   notificationActivityShort: queryPageRequest('notification/activity/short'),
   notificationActivity: queryPageRequest('notification/activity'),
   notificationAnnouncementShort: queryPageRequest('notification/announcement/short'),
   notificationAnnouncement: queryPageRequest('notification/announcement'),
 
   //Topbar Right Announcement
   notificationTaskNewCount: newCount('notification/task/newcount'),
   notificationActivityNewCount: newCount('notification/activity/newcount'),
   notificationAnnouncementNewCount: newCount('notification/announcement/newcount'),
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
